module.exports = "../../app/cells/pages/rankings/subscriptions/show/benefits/action.erb";